import React from "react";
import { OrderedListOutlined } from "@ant-design/icons";
import { DataTable } from "./DataTable";
import { YhBox } from "@components/YhBox";
import { Button } from "antd";
import { useNoticeModel } from "./summaryModel";
import useNavModel from "@src/model/navModel";
import { IMdNoticeDetail } from "../NoticeTypes";
import { YhAuth } from "@src/components/auth/YhAuth";

export const DataBox = () => {
    const { setEditModel, setSelectedRowData, setDrawerVisible } = useNoticeModel();
    const { addNav } = useNavModel()
    const onAdd = () => {
        setSelectedRowData({} as IMdNoticeDetail)
        addNav("portal-04-01")
        setEditModel("add")
    }

    const action = (
        <>
            <YhAuth resCode="portal2.n.issue">
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onAdd}
                >发布公告</Button>

            </YhAuth>
        </>
    );

    return (
        <YhBox title={<OrderedListOutlined />} action={action}>
            <DataTable />
        </YhBox>
    )
}